import React, { useEffect } from 'react';
import { useGame } from '../contexts/GameContext';
import { useAuth } from '../contexts/AuthContext';
import { TrophyIcon, LockClosedIcon, LockOpenIcon } from '@heroicons/react/24/outline';

function Achievements() {
  const { achievements, checkAchievements } = useGame();
  const { user } = useAuth();

  useEffect(() => {
    checkAchievements();
  }, [checkAchievements]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f56756] to-[#402e2c] p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-white">Achievements</h1>
          <div className="flex items-center gap-2 text-[#402e2c]">
            <TrophyIcon className="h-5 w-5" />
            <span>
              {achievements.filter(a => a.unlocked).length}/{achievements.length} Unlocked
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {achievements.map((achievement) => (
            <div
              key={achievement.id}
              className={`bg-[#b34e42]/80 backdrop-blur-sm rounded-2xl p-6 border ${
                achievement.unlocked
                  ? 'border-[#402e2c]/20'
                  : 'border-gray-600/20'
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-4">
                  <div
                    className={`p-3 rounded-full ${
                      achievement.unlocked
                        ? 'bg-[#402e2c]/20'
                        : 'bg-gray-600/20'
                    }`}
                  >
                    <span className="text-2xl">{achievement.icon}</span>
                  </div>
                  <div>
                    <h3
                      className={`text-xl font-semibold ${
                        achievement.unlocked ? 'text-white' : 'text-gray-400'
                      }`}
                    >
                      {achievement.title}
                    </h3>
                    <p className="text-gray-400 mt-1">{achievement.description}</p>
                  </div>
                </div>
                <div>
                  {achievement.unlocked ? (
                    <LockOpenIcon className="h-6 w-6 text-[#402e2c]" />
                  ) : (
                    <LockClosedIcon className="h-6 w-6 text-gray-600" />
                  )}
                </div>
              </div>

              <div className="mt-4 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <TrophyIcon
                    className={`h-5 w-5 ${
                      achievement.unlocked
                        ? 'text-[#402e2c]'
                        : 'text-gray-600'
                    }`}
                  />
                  <span
                    className={
                      achievement.unlocked
                        ? 'text-[#402e2c]'
                        : 'text-gray-600'
                    }
                  >
                    {achievement.reward} coins
                  </span>
                </div>
                <div
                  className={`px-3 py-1 rounded-full text-sm ${
                    achievement.unlocked
                      ? 'bg-[#402e2c]/20 text-[#402e2c]'
                      : 'bg-gray-600/20 text-gray-600'
                  }`}
                >
                  {achievement.unlocked ? 'Unlocked' : 'Locked'}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Achievements; 